export default "<button mat-icon-button (click)=\"downloadAsPDF()\">\n  <ion-icon name=\"icon-download\"></ion-icon>\n</button>\n";